import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import SlackActionMetadata from 'automation-ui-action-features/actions/slack/records/SlackActionMetadata';
import SlackActionDetail from 'automation-ui-action-features/actions/slack/SlackActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
export default class SlackActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      flowObjectTypeId,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(SlackActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
}
SlackActionHistoryCard.propTypes = {
  actionLabel: PropTypes.node,
  actionMetadata: PropTypes.instanceOf(SlackActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired
};